import {Grid, Theme, useMediaQuery, SxProps} from '@mui/material';
import {Stack} from '@mui/system';
import {FC} from 'react';
import {IMenuItem, IMenuItemDynamicLink} from '../../shared/types/menu.types';
import {NavCard} from './NavCard';

interface INavCards {
  menu: (IMenuItem | IMenuItemDynamicLink)[];
  variant?: 'grid' | 'flexrow';
  sxTitle?: SxProps<Theme>;
}

const NavCards: FC<INavCards> = ({menu, variant, sxTitle}) => {
  const matches = useMediaQuery('(max-width: 1599px)');

  if (variant) {
    return variant === 'grid' ? (
      <Grid container columns={12} spacing={2} rowSpacing={3}>
        {menu.map((item, id) => (
          <Grid justifySelf={'center'} item key={id} xs={2}>
            <NavCard sxTitle={sxTitle} useMediaForce={true} item={item} />
          </Grid>
        ))}
      </Grid>
    ) : (
      <Stack direction="row" spacing={4}>
        {menu.map((item, id) => (
          <NavCard sxTitle={sxTitle} key={id} item={item} />
        ))}
      </Stack>
    );
  }

  return !matches ? (
    <Stack direction="row" spacing={4}>
      {menu.map((item, id) => (
        <NavCard sxTitle={sxTitle} key={id} item={item} />
      ))}
    </Stack>
  ) : (
    <Grid container columns={12} spacing={2} rowSpacing={3}>
      {menu.map((item, id) => (
        <Grid justifySelf={'center'} item key={id} xs={4}>
          <NavCard sxTitle={sxTitle} item={item} />
        </Grid>
      ))}
    </Grid>
  );
};

export default NavCards;
